import styled from 'styled-components'

interface IBudgetCategoryCardStyledProps {}

export const BudgetCategoryCardStyled = styled.div<IBudgetCategoryCardStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  border: 1px solid ${(props) => props.theme.colors.content.border};
  border-radius: ${(props) => props.theme.typography.pxToRem(4)};
  padding: 1.5rem;
`
